import queryString from "query-string";
import {
  DeleteLogoParams,
  GetListParams,
  GetParams,
  PatchIntroVideoParams,
  TenantRepositoryInterface,
} from "./tenant.repository.d";
import { BaseRepository } from "../Base/base.repository";
import { GetTenantDto } from "./dto/get.dto";
import { ServerlessConfigure } from "../../config/serverless-configure";
import { CreateTenantDto } from "./dto/create.dto";
import { UpdateTenantDto } from "./dto/update.dto";

export class TenantRepository
  extends BaseRepository<GetTenantDto>
  implements TenantRepositoryInterface
{
  constructor() {
    super(
      {
        baseURL: ServerlessConfigure.ApiEndpoint,
      },
      {
        hasSendToken: true,
      },
    );
  }

  async get(params: GetParams) {
    const { id } = params;
    const response = await this.apiRequest.get({
      url: `/tenants/${id}`,
    });

    return response.data;
  }

  async getList(params: GetListParams) {
    const response = await this.apiRequest.getList({
      url: `/tenants?${queryString.stringify(params)}`,
    });

    return response.data.Items;
  }

  async create(params: CreateTenantDto) {
    const response = await this.apiRequest.post<GetTenantDto>({
      url: `/tenants`,
      data: params,
    });

    return response;
  }

  async update(params: UpdateTenantDto) {
    const response = await this.apiRequest.put<GetTenantDto>({
      url: `/tenants/${params.id}`,
      data: {
        tenantEmail: params.tenantEmail,
        tenantAddress: params.tenantAddress,
        tenantName: params.tenantName,
        isActive: params.isActive,
        tenantLogoImageBase64: params.tenantLogoImageBase64,
        tenantProjectId: params.tenantProjectId,
        tenantModelId: params.tenantModelId,
        allowOpenAccess: params.allowOpenAccess,
        allowGuestAccess: params.allowGuestAccess,
      },
    });

    return response;
  }

  async deleteLogo(params: DeleteLogoParams) {
    const { id } = params;
    const response = await this.apiRequest.delete({
      url: `/tenants/${id}/logo`,
    });
    return response.data;
  }

  async patchIntroVideo(params: PatchIntroVideoParams) {
    const { tenantId, introVideoS3Key } = params;
    const response = await this.apiRequest.patch<GetTenantDto>({
      url: `/tenants/${tenantId}/patchIntroVideo`,
      data: {
        introVideoS3Key,
      },
    });

    return response.data;
  }
}
